import React, { useState, useRef } from 'react';

export function Accordion(props) {
    const { item } = props;
    const [active, setActive] = useState(false);
    const content = useRef(null);

    return (
        <div className="border-top border-top--dashed mb-32px">
            <button type="button" onClick={() => setActive(!active)}>
                <h3 className="h3 m-0">{item.accordionLabel}</h3>
            </button>
            <div
                style={{
                    height: active ? `${content.current.scrollHeight + 36}px` : 0,
                    overflow: 'hidden',
                    transition: 'all 400ms',
                }}>
                <div
                    ref={content}
                    style={{ marginTop: 36 }}
                    className="rich-text"
                    dangerouslySetInnerHTML={{ __html: item.accordionContent }}
                />
            </div>
        </div>
    );
}

export default function AccordionBlock(props) {
    const { data } = props;
    const items = data.accordionItem;

    return (
        <div>
            {items.map((item, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <Accordion key={`item-${i}`} item={item} />
            ))}
        </div>
    );
}
